import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import moment from 'moment'
import PropTypes from 'prop-types'
import GoogleMap from 'components/shared/map/search'
import SubmitButton from 'forms/shared/buttons/submit'
import * as types from 'actions/leads/types'
import Space from './space'
import InquiryData from './inquiry-data'
import ScheduleTourForm from './form'

const term = { hourly: 'hour', daily: 'day', monthly: 'month' }

const Proposal = ({
  leadDetail,
  proposalDetail,
  handleMessageOrProposal,
  inquiry,
  dispatch,
  refreshInquiry,
}) => {
  const [isOpenPopupEdit, setIsOpenPopupEdit] = useState(false)
  const modalRef = useRef(null)
  const detailRequest = inquiry.details
  const pricesString = inquiry.prices.map((item) => `${item.amount}/${term[item.type]}`).join(', ')

  const fieldValues = [
    { field: 'email', value: detailRequest.email },
    { field: 'phone', value: detailRequest.phone },
    { field: 'fullName', value: detailRequest.client },
    { field: 'space', value: `${inquiry.space} - ${pricesString}` },
    {
      field: 'schedule',
      value: moment(detailRequest.requestDate, 'dddd MMMM DD, YYYY [at] hh:mmA').toDate(),
    },
    {
      field: 'time',
      value: moment(detailRequest.requestDate, 'dddd MMMM DD, YYYY [at] hh:mmA').toDate(),
    },
  ]

  const initialValues = {
    email: detailRequest.email,
    phone: detailRequest.phone,
    fullName: detailRequest.client,
    space: `${inquiry.space} - ${pricesString}`,
    schedule: moment(detailRequest.requestDate, 'dddd MMMM DD, YYYY [at] hh:mmA').toDate(),
    time: moment(detailRequest.requestDate, 'dddd MMMM DD, YYYY [at] hh:mmA').toDate(),
  }

  const setFieldValue = () => {
    fieldValues.forEach(({ field, value }) => {
      dispatch(change('public-schedule-tour-edit-form', field, value))
    })
  }

  useEffect(() => {
    setIsOpenPopupEdit(false)
    setFieldValue()
  }, [inquiry.conversation_id])

  useEffect(() => {
    if (isOpenPopupEdit) document.body.style.overflowY = 'hidden'

    return () => {
      document.body.style.overflowY = 'unset'
    }
  }, [isOpenPopupEdit])

  let checkOut = proposalDetail.check_out
    ? moment(proposalDetail.check_out).format('MMMM DD, YYYY-hh:mm A')
    : ''
  if (checkOut) {
    checkOut = `${checkOut.split('-')[0]}
    ${checkOut.split('-')[1]}`
  }
  let checkIn = proposalDetail.check_in
    ? moment(proposalDetail.check_in).format('MMMM DD, YYYY-hh:mm A')
    : ''
  if (checkIn) {
    checkIn = `${checkIn.split('-')[0]}
    ${checkIn.split('-')[1]}`
  }
  const noImage = require('assets/images/no-image.jpg')
  const mapData = {
    id: leadDetail.space_id,
    coordinates: {
      lat: leadDetail.lat,
      lng: leadDetail.lng,
    },
    imageSrc: leadDetail.image ? leadDetail.image : noImage,
  }
  const leadTypeMap = {
    bookavisit: 'Book A Visit',
    inquiry: 'Inquiry',
  }
  const containerStyle = {
    height: '40%',
    width: '90%',
    left: '5%',
  }
  const handleClick = () => {
    const data = {
      proposalId: proposalDetail.proposal_id,
      action: 'view-proposal',
    }
    handleMessageOrProposal(data)
  }

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setIsOpenPopupEdit(false)
    }
  }

  const handleSubmitPopup = (values) => {
    const { schedule, time } = values
    const initialSchedule = initialValues.schedule
    const initialTime = initialValues.time

    if (
      schedule.getTime() !== initialSchedule.getTime() ||
      time.getHours() !== initialTime.getHours()
    ) {
      refreshInquiry({
        inquiryId: inquiry.id,
        conversationId: inquiry.conversation_id,
        scheduleDate: values.schedule.toLocaleDateString(),
        scheduleTime: values.time.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
        }),
      })
      setIsOpenPopupEdit(false)
    } else {
      setIsOpenPopupEdit(false)
    }
  }

  return (
    <div className="lg:block hidden proposal">
      <div className="m_5">
        <div className="flex justify-between mb-4">
          <h5 className="text-sm text-gray-700 font-bold uppercase">REQUEST DETAILS</h5>
          {leadDetail?.status === 'pending' && (
            <h5
              className="text-sm cursor-pointer text-orange-400 font-medium"
              onClick={() => setIsOpenPopupEdit(true)}
            >
              Edit
            </h5>
          )}
          {isOpenPopupEdit && (
            <div
              className="popup-overlay fixed w-screen h-screen pt-10 z-50 left-0 top-0 bg-overlay-bg flex justify-center items-center"
              onClick={handleOverlayClick}
            >
              <div className="popup-content bg-white px-8 py-12 shadow-md max-w-lg rounded-xl" ref={modalRef}>
                <h3 className="text-2xl font-bold text-center leading-7 mb-7">
                  Edit your viewing request details
                </h3>
                <ScheduleTourForm
                  form="public-schedule-tour-edit-form"
                  initialValues={initialValues}
                  onSubmit={(values) => handleSubmitPopup(values)}
                />
                <SubmitButton
                  className="btn btn-primary font-normal w-full"
                  formName="public-schedule-tour-edit-form"
                >
                  Submit
                </SubmitButton>
              </div>
            </div>
          )}
        </div>
        <Space
          image={leadDetail.image ? leadDetail.image : noImage}
          title={leadDetail.space_name}
          address={leadDetail.address}
          spaceUrl={leadDetail.space_url}
        />
        <div className="flex items-start justify-between">
          <InquiryData label={'LEAD TYPE'} value={leadTypeMap[leadDetail.lead_type]} />
          <InquiryData
            label={'REQUEST DATE'}
            value={moment(detailRequest.requestDate, 'dddd MMMM DD, YYYY [at] hh:mmA').format(
              'MMMM DD, YYYY HH:mm:ss'
            )}
          />
        </div>
        <div className="flex items-start justify-between">
          <InquiryData label="CHECK-IN" value={checkIn} />
          <InquiryData label="CHECK-OUT" value={checkOut} />
        </div>
        <div className="flex items-start justify-between">
          <InquiryData
            label="NUMBER OF GUESTS"
            value={proposalDetail.numberOfGuest ? `${proposalDetail.numberOfGuest} Guests` : ''}
          />
          <InquiryData
            label="TOTAL AMOUNT"
            value={
              proposalDetail.payment_amount
                ? `${proposalDetail.currency} ${proposalDetail.payment_amount}`
                : ''
            }
          >
            <div
              onClick={handleClick}
              className="text-primary-orange uppercase text-sm font-semibold cursor-pointer"
            >
              View Proposal
            </div>
          </InquiryData>
        </div>
      </div>
      <GoogleMap
        lat={leadDetail.lat}
        lng={leadDetail.lng}
        zoom={12}
        data={[mapData]}
        onMapMove={() => {}}
        containerStyle={containerStyle}
      />
    </div>
  )
}

Proposal.propTypes = {
  leadDetail: PropTypes.object,
  proposalDetail: PropTypes.object,
  handleMessageOrProposal: PropTypes.func,
  inquiry: PropTypes.object,
  dispatch: PropTypes.func,
  refreshInquiry: PropTypes.func,
}

const mapStateToProps = ({ messages }) => ({
  leadDetail: messages.index.leadDetail || {},
  proposalDetail: messages.index.proposalDetail || {},
  inquiry: messages && messages.index.inquiry,
})

const mapDispatchToProps = (dispatch) => ({
  refreshInquiry: (payload) => dispatch({ type: types.REFRESH_INQUIRY, payload }),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(Proposal)
